export default function PHP_mt_getrandmax() {
  return (
    <div>
      <h1>PHP_mt_getrandmax</h1>
    </div>
  );
}
